import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { CommunicationService } from '../service/communication.service';
var DeleteCommunicationComponent = /** @class */ (function () {
    function DeleteCommunicationComponent(_matDialogRef, data, _commService) {
        this._matDialogRef = _matDialogRef;
        this._commService = _commService;
        this.isLoading = false;
        this.commId = data.commId;
        this.frequencyId = data.frequencyId;
        this.airportId = data.airportId;
    }
    DeleteCommunicationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
    };
    DeleteCommunicationComponent.prototype.close = function (data) {
        this._matDialogRef.close(data);
    };
    DeleteCommunicationComponent.prototype.delete = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var flightComm, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        this.isLoading = true;
                        return [4 /*yield*/, this._commService.deleteFrequency(this.airportId, this.frequencyId)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this._commService.getComm(this.airportId, this.commId)];
                    case 2:
                        flightComm = _a.sent();
                        if (!(flightComm.frequencies && flightComm.frequencies.length === 0)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._commService.deleteComm(this.airportId, this.commId)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.isLoading = false;
                        this.close({ success: true, commId: this.commId });
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        this.close({ success: false, error: e_1 });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    DeleteCommunicationComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    return DeleteCommunicationComponent;
}());
export { DeleteCommunicationComponent };
